import { ContextAction } from '../types';
import type {
  ActiveFeatureConfigAction,
  ActiveFeatureConfigState
} from './types';

export const activeFeatureConfigInitial = {};

export const activeFeatureConfigReducer = (
  state: ActiveFeatureConfigState,
  action: ActiveFeatureConfigAction
): ActiveFeatureConfigState => {
  switch (action.type) {
    case ContextAction.setActiveFeatureConfig:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};
